/** @format */
import TableRow from "./TableRow";
const TableBody = ({ rows, firstIndex, showActions, onProfileClick }) => {
  return (
    <tbody className="font-Inter w-16 md:w-32 lg:w-48 text-sm cursor-pointer">
      {rows.map((row, index) => (
        <TableRow
          key={index}
          row={row}
          index={firstIndex + index + 1}
          showActions={showActions}
          onProfileClick={onProfileClick}
        />
      ))}
    </tbody>
  );
};

export default TableBody;
